export function customConverter() {
  return {
    fromAttribute: (value: string) => {
      return !value || value === 'false' ? false : true;
    },
    toAttribute: (value: string) => {
      return value ? 'true' : 'false';
    }
  };
}
